import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Col, Modal, ModalBody, Row } from "reactstrap";
import { Tooltip } from "@mui/material";
import Badge from "react-bootstrap/Badge";
import PndRestApi from "src/utils/pnd/PndRestApi";
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import ReactTableBase from "src/shared/components/table/ReactTableBase";
import { showNotification, successNofication } from "src/shared/components/Notification";
import Radio from '@mui/material/Radio';
import { Cancel, Person } from '@mui/icons-material';
import { ERROR_MESSAGES, OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT } from '../../../../../../../utils/pnd/PndConstants';
import { Redirect } from 'react-router-dom';


const FreeRiderDetails = ({ modalShow, setModalShow, isOrderNo, setSelectedDriverId, selectedDriverId,
    isOrderId, isOperationType, selectedOrderIds, isOrderType, setRedirect, isRiderId, setBulkUploadReDirect }) => {
    useEffect(() => {
        GetAllFreeRiderDetails();
    }, []);

    
    const [selectedItem, setSelectedItem] = useState(0); //initial selected value
    const [reactTableData, setReactTableData] = useState([]);
    const [isTempData, setTempData] = useState(null);

    let Icon;

    
    const OrderStatusUpdate = async () => { //use for individual order status update
        try {
          
            let Obj = {};
            Obj["operationType"] = isOperationType;
            Obj["orderIds"] = [isOrderId];
            Obj["hubId"] = isTempData?.hubId;
            Obj["newRiderId"] = selectedDriverId ? selectedDriverId : null; //new rider Id
            Obj["newRiderVehicleId"] = isTempData?.vehicleId; //new rider VehicleId
            Obj["newRiderStatusId"] = isTempData?.riderStatusId; //new rider Status
            Obj["ratsId"] = selectedOrderIds[0]?.ratsId; //current Rats Id, it single
            const response = await PndRestApi.ProcessOrderReassignment(Obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `Message: Order has been successfully reassigned to a different rider.`
                );
                toggle();
                if (typeof setBulkUploadReDirect === 'function') setBulkUploadReDirect();
                else if (setRedirect) setRedirect(true);
                else window.location.reload();
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } 
    };


    const OrderBulkAssignment = async () => { //use for individual order status update
        try {
           
            let Obj = {};
            Obj["operationType"] = OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT;
            if (OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT == Obj["operationType"]) {
                const orderIdStrings = selectedOrderIds.map(order => String(order.id));
                const orderIdIntegers = orderIdStrings.map(id => parseInt(id, 10));
                Obj["orderIds"] = orderIdIntegers;
            } else {
                Obj["orderId"] = isOrderId;
            }
                Obj["operationType"] = isOperationType;
                Obj["hubId"] = isTempData?.hubId;
                Obj["newRiderId"] = selectedDriverId ? selectedDriverId : null; //new rider Id
                Obj["newRiderVehicleId"] = isTempData?.vehicleId; //new rider VehicleId
                Obj["newRiderStatusId"] = isTempData?.riderStatusId; //new rider Status
                Obj["ratsId"] = selectedOrderIds[0]?.ratsId; //current Rats Id, it single}



                        const response = await PndRestApi.ProcessOrderReassignment(Obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `Message: Order Status Updated Successfully`
                );
                toggle();
                if (typeof setBulkUploadReDirect === 'function') setBulkUploadReDirect();
                else if (setRedirect) setRedirect(true);
                else window.location.reload();

            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };
    const handleAssignButtonClick = (event) => {
        event.preventDefault(); // Prevent default form submission behavior
        if (isOperationType === OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT)
            OrderBulkAssignment();
        else {
            OrderStatusUpdate();
        }
    };
    const GetAllFreeRiderDetails = async () => {
        try {
               let filteredData;
            let orderType = isOrderType ? isOrderType : 0; //isOrderType will be 3 for PnD if the bulk assignment it is 0 always
            const response1 = await PndRestApi.GetAllFreeRidersDetails(orderType,-1); //3-PnD
            if (response1 && response1.status === 200 && response1.data.status === 200) {
                // Filter out items where isRiderId is present
            
                if(isRiderId){
                filteredData = response1.data.data.filter(item => item.riderId!==isRiderId);
                }
                if (selectedOrderIds && selectedOrderIds.length > 0) {
                    filteredData = response1.data.data.filter(item => 
                        !selectedOrderIds.some(selected => selected.riderId === item.riderId)
                    );
                }
                
               // const filteredData = response1.data.data;
                // Check if there is any data left after filtering
                if (filteredData.length > 0) {
                    setReactTableData({ tableHeaderData: columns, tableRowsData: filteredData });
                }
            } else if(response1.data.status === 204){
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response1.data.status}`,
                    `Message:All Riders are Busy at this moment to reassign the orders.`,
                );
                toggle();
                return;
            }
            if(filteredData.length ==0){
               showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response1.data.status}`,
                    `Message:All Riders are Busy at this moment to reassign the orders.`,
                );
                toggle();
                return; 
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                "Error",
                "Error while fetching the Data",
            );
        } 
    };


    const toggle = () => {
        setModalShow(prevState => !prevState)
    }

    const handleRadioClick = (event, temData) => {
        setSelectedDriverId(temData?.riderId);
        setTempData(temData);
    };
   
    const columns = useMemo(
        () => [
            {
                Header: 'Selection',
                accessor: 'riderId',
                disableSortBy: true,
                width: 60,
                Cell: ({ row }) => (
                    <div>
                        {(row.original.vehicleId !== null) && (
                            <Radio 
                                checked={selectedDriverId !== null && row.original.riderId === selectedDriverId}
                                onClick={(event) => {
                                    handleRadioClick(event, row.original) 
                                }}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: '#',
                accessor: 'id',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Vehicle Plate No.',
                accessor: 'plateNo',
                Cell: ({ value }) => {
                    return value ? (
                        <span>{value}</span>
                    ) : (
                        <Tooltip title="No Vehicle is Assigned to him">
                            <Cancel style={{ color: 'red' }} />
                        </Tooltip>
                    );
                },
                disableGlobalFilter: false,
            },
            {
                Header: 'Rider Name',
                accessor: 'riderName',
                disableGlobalFilter: true,
                Cell: ({ value }) => (
                    <div style={{ display: 'flex', alignItems: 'center', fontWeight: '600', color: '#2c3e50' }}>
                        <div style={{ backgroundColor: '#e3f2fd', borderRadius: '50%', padding: '4px', marginRight: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Person style={{ color: '#1976d2', fontSize: '18px' }} />
                        </div>
                        {value}
                    </div>
                )
            },
            {
                Header: 'Rider Unique Id',
                accessor: 'riderUniqueId',
                disableGlobalFilter: true,
            },

            {
                Header: "Rider Status",
                accessor: "riderStatusInfo",
                disableSortBy: false,
              
                Cell: ({ row }) => (<>
                    {row.original?.riderStatusId === 3 ? (
                        <h6><Badge bg="success">{row.original?.riderStatusDesc}</Badge></h6>
                    ) : row.original?.riderStatusId === 6 ? (
                        <h6><Badge bg="primary">{row.original?.riderStatusDesc}</Badge></h6>
                    ) : row.original?.riderStatusId === 9 && (
                        <h6><Badge bg="warning">{row.original?.riderStatusDesc}</Badge></h6>
                    )
                    }
                </>)
            },
            // {
            //     Header: 'Assigned Order Type',
            //     accessor: 'assignedOrderType',
            //     disableGlobalFilter: false,
            // },
            {
                Header: 'TTH (min)',
                accessor: 'travelTimeToHub',
                disableGlobalFilter: true,
            },

            {
                Header: 'Idle Time',
                accessor: 'idleTime',
                disableGlobalFilter: false,
            },

        ],
        [reactTableData, selectedItem, selectedDriverId]);

    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: true,
        withPagination: true,
        withSearchEngine: true,
        manualPageSize: [10, 50, 100, 1000],
        placeholder: 'Search by Rider Name, Plate No. ...',
    };
    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName={`ltr-support`}
                className="theme-light ltr-support credit-memo-modal-form-ani">
                <div className="modal__header">
                    <button
                        className="lnr lnr-cross modal__close-btn"
                        aria-label="modal__close-btn"
                        type="button"
                        onClick={toggle}
                    />
                    {Icon}
                    {isOrderNo &&
                        <h4 className="text-modal  modal__title mt-1 text-uppercase"  >
                            Selected Order No. is {isOrderNo}
                        </h4>
                    }
                </div>
                <ModalBody className="m-0">
                    <div className="credit-memo-modal-form-ani">
                        {/* <span className="account__logo">
                            <span className="account__logo-accent text-light"> */}
                                <form className="form-animated" >
                                    <Col lg={12} md={12}>
                                        <Row>
                                            <Col lg={12} md={12}>
                                                {
                                                    reactTableData && reactTableData?.tableRowsData &&
                                                    <ReactTableBase
                                                        name={"t('instution_type.view.name_map')"}
                                                        key={'searchable'}
                                                        columns={columns}
                                                        data={reactTableData?.tableRowsData}
                                                        tableConfig={tableConfig}

                                                    />
                                                }
                                            </Col>
                                        </Row>

                                    </Col>
                                    {/* : <div style={{color:"black"}}>Right now all the Riders are Busy</div> */}
                                    {isTempData &&
                                        <div className="form__OnboardingButton">
                                            <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                                                <Button color="primary" type="button" className="next" onClick={handleAssignButtonClick}>Re-Assign</Button>
                                            </ButtonToolbar>
                                        </div>
                                    }
                                </form>
                            {/* </span>
                        </span> */}
                    </div>

                </ModalBody>
            </Modal>
        </div>
    );
};


FreeRiderDetails.propTypes = {
    FreeRiderDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {};
};
export default connect(mapStateToProps)(reduxForm({ form: 'FreeRiderDetailsForm', enableReinitialize: true })(FreeRiderDetails));

